import React from 'react';
import { useTranslation } from 'react-i18next';

import type IProfitCentresSection from './interfaces/IProfitCentresSection';

import styles from './sass/ProfitCentresSection.module.scss';

function ProfitCentresSection({
  impactedProfitCentresCount,
  profitCentresPercentage,
  totalProfitCentresCount,
}: IProfitCentresSection): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <section className={styles.tile}>
      <h4 className={styles.tileTitle}>{t('valueChainMap.resultCardProfitCentres')}</h4>
      <div className={styles.tileValue}>
        {profitCentresPercentage}
        %
      </div>
      <p className={styles.descMeta}>
        <span className={styles.metaAccent}>{impactedProfitCentresCount}</span>
        {`/${totalProfitCentresCount} ${t('valueChainMap.resultCardCentres')}`}
      </p>
    </section>
  );
}

export default ProfitCentresSection;
